module.exports = __webpack_public_path__ + "img/mono-rounded.bb8fdc99.svg";